import { Platform } from 'react-native';

type SharedEnvValue =
  | 'NODE_ENV'
  | 'REACT_APP_API_URL'
  | 'REACT_APP_KRATOS_URL'
  | 'REACT_APP_GOOGLE_MAPS_API_KEY'
  | 'REACT_APP_TENANT_NAME'
  | 'REACT_APP_TENANT_ID';

export const getEnvValue = (envKey: SharedEnvValue): string => {
  if (Platform.OS === 'web') {
    return process.env[envKey] as string;
  }

  // eslint-disable-next-line
  const { Config } = require('react-native-config');
  return Config[envKey];
};
